import { render, staticRenderFns } from "./TaskButtons.vue?vue&type=template&id=d453cee4&scoped=true"
import script from "./TaskButtons.vue?vue&type=script&lang=js"
export * from "./TaskButtons.vue?vue&type=script&lang=js"
import style0 from "./TaskButtons.vue?vue&type=style&index=0&id=d453cee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d453cee4",
  null
  
)

export default component.exports